import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import type {
  GetInsuranceClaimSummaryRequest,
  GetInsuranceClaimSummaryResponse,
} from '../@types/contracts';
import { makeAPIRequestV2 } from '../utils/api';

import { endpoints } from './endpoints';

interface InsuranceClaimSummaryParams extends GetInsuranceClaimSummaryRequest {
  patientId: string;
  patientName: string;
  imageAnalysisRecordIds: string[];
  practiceId: string;
  confidenceScore?: number;
}

export const useGetInsuranceClaimSummary = () =>
  useMutation<
    GetInsuranceClaimSummaryResponse,
    AxiosError,
    InsuranceClaimSummaryParams
  >(async (input: InsuranceClaimSummaryParams) => {
    const { data } = await makeAPIRequestV2(
      `/${endpoints.insuranceClaim}/${endpoints.pdfSummary}`,
      { data: input },
      'POST',
    );
    return data;
  });

export const generateInsuranceClaimSummaryRequest = (
  patientId: string,
  patientName: string,
  imageAnalysisRecordIds: string[],
  practiceId: string,
  confidenceScore?: number,
): InsuranceClaimSummaryParams => {
  return {
    patientId,
    patientName: patientName ? patientName : 'Unknown Patient',
    imageAnalysisRecordIds,
    practiceId,
    confidenceScore,
  };
};
